import React, { Fragment, useEffect } from "react";
import { useClassList } from "../Hooks";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";

function List() {
  const { data, loading, getData, deleteClass } = useClassList();
  const { slug } = useParams();
  useEffect(() => {
    getData(slug);
  }, []);
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Fragment>
      <DataTable
        loading={loading.listLoading}
        heads={[
          {
            title: "اسم کلاس",
            key: "name",
          },
          {
            title: "قیمت",
            key: "price",
            keyName: "price",
          },
          {
            title: "ظرفیت",
            key: "capacity",
          },
          {
            title: "تعداد جلسات",
            key: "count_session",
          },
          {
            title: "تعداد جلسات",
            key: "count_session",
          },
          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        data={data}
        list={data.data}
        textEmpty="کلاسی برای این برگزار کننده ثبت نشده"
        header=" لیست کلاس ها"
        textbtn="ایجاد کلاس "
        linkbtn={`/Admin/Classes/CreateClass/${slug}`}
        links={[
          {
            function: selected => {
              navigate("/Admin/SingleClass", {
                state: {
                  data: data.data.filter(item => item.id === selected[0])[0],
                },
              });
            },
            color: "success",
            size: "col-md-4",
            html: "مشاهده کلاس ",
            type: "show",
            main: true,
          },

          {
            function: selected => {
              deleteClass(selected[0], slug);
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "edit",
          },
        ]}
      />
    </Fragment>
  );
}

export default List;
